import React, { useEffect, useRef } from 'react';
import { Avatar as AvatarClass } from '../../utils/avatar';

interface AvatarProps {
  size?: number | string | undefined;
  teamId?: number | string;
  type?: 'Account' | 'Contact';
  personId?: string;
  rlpPersonId?: string;
  avatarUrl?: string;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
  size,
  teamId,
  type,
  personId,
  rlpPersonId,
  avatarUrl,
  className
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const avatarInstance = useRef<AvatarClass | null>(null);

  useEffect(() => {
    // Initialize avatar instance
    const sizeNumber = size ? (typeof size === 'string' ? parseInt(size, 10) : size) : undefined;
    avatarInstance.current = new AvatarClass({ size: sizeNumber });

    if (containerRef.current) {
      const avatar = avatarInstance.current.create({
        teamId,
        type,
        personId,
        rlpPersonId,
        avatarUrl
      });

      containerRef.current.innerHTML = '';
      containerRef.current.appendChild(avatar);
    }

    // Cleanup
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [size, teamId, type, personId, rlpPersonId, avatarUrl]);

  return <div ref={containerRef} className={className} />;
};
